/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Needs_PropertyInputs */

const cs_tasks_protocol_needs_property = /** @type {(inputs: Tasks_Protocol_Needs_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejdřív propojte úkol s nemovitostí.`)
};

const en_tasks_protocol_needs_property = /** @type {(inputs: Tasks_Protocol_Needs_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link a property to this task before generating a protocol.`)
};

/**
* | output |
* | --- |
* | "Link a property to this task before generating a protocol." |
*
* @param {Tasks_Protocol_Needs_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_needs_property = /** @type {((inputs?: Tasks_Protocol_Needs_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Needs_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_needs_property(inputs)
	return cs_tasks_protocol_needs_property(inputs)
});